import styled from '@emotion/styled';

import { Team } from 'modules/teams/domain/interfaces/team';
import { CreatableSelectOption } from 'ud-form/components/select/component';
import TeamLogo from 'ud-ui/components/team-logo';

/**
 * Опция селекта команд. Сама команда лежит в `data` — по ней вызывающая сторона
 * достаёт id при отправке формы.
 */
export type TeamSelectOption = CreatableSelectOption<number, Team>;

const TeamSelectOptionRow = styled.div`
  display: flex;
  align-items: center;

  .team-select-logo {
    margin-right: 8px;
  }
`;

interface TeamOptionProps {
  team: Team;
}

export function TeamOption({ team }: TeamOptionProps) {
  return (
    <TeamSelectOptionRow>
      <TeamLogo className="team-select-logo" url={team.logo?.url} size={32} />
      {team.name} {team.shortName ? `(${team.shortName})` : ''}
    </TeamSelectOptionRow>
  );
}

export const teamToTeamOption = (team: Team): TeamSelectOption => ({
  label: <TeamOption team={team} />,
  value: team.id,
  data: team,
});
